import { VERFAHREN_STATES } from '../types';
import GenericStateBadge from './GenericStateBadge';

export default function VerfahrenStateBadge({
  staat,
  small,
  statesMap,
}: {
  staat: string;
  small?: boolean;
  statesMap?: Record<string, { label: string; color: string }>;
}) {
  return <GenericStateBadge value={staat} statesMap={statesMap ?? VERFAHREN_STATES} small={small} />;
}
